import { motion } from "framer-motion";

const ScrollToTopButton = ({ onClick, visible, classNew }) => {
  if (!visible) return null;

  return (
    <motion.button
      onClick={onClick}
      className={
        classNew ||
        "fixed bottom-10 right-10 w-10 h-10 bg-foreground flex items-center justify-center text-white p-3 rounded-full shadow-lg z-50"
      }
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
        <path
         className="fill-primary"
          d="M4 8l5 -5l5 5l-1 1l-4 -4l-4 4ZM4 12l5 -5l5 5l-1 1l-4 -4l-4 4Z"
        />
      </svg>
    </motion.button>
  );
};

export default ScrollToTopButton;
